<div class="ot-splash-screen ot-splash-screen--has-gradient-bg otsc-login-screen" role="main">
  <ng-scrollbar>
    <div class="otsc-login-container">
      <div class="otsc-login-wrapper">
        <div class="ot-splash-screen__heading ot-mb-1">
          <img i18n-alt alt="System Center" src="./assets/icons/header_opentext_li.svg" il8n-title title="OpenText"
            class="ot-header__logo otsc-header__logo">
          <p class="otsc-splash-screen__title">
            {{systemCenterProductVersion.name}}
          </p>
          <span class="otsc-splash-screen__title_version ot-pl-1">
            {{systemCenterProductVersion.version}}
          </span>
        </div>
        <div
          [ngClass]="loginState.toString() === LoginStateEnum.Welcome || loginState.toString() === LoginStateEnum.ForgotPassword || loginState.toString() === LoginStateEnum.PasswordWasReset ? 'otsc-login-message' : 'otsc-login-message-error'"
          role="alert">
          @if (loginState.toString() === LoginStateEnum.Welcome) {
          <p i18n>Sign in to continue to System Center</p>
          }
          @if (loginState.toString() === LoginStateEnum.PasswordWasReset) {
          <p i18n>Your password has been reset. Please
            sign-in with your new password.</p>
          }
          @if (loginState.toString() === LoginStateEnum.InvalidUsernameOrPassword) {
          <p i18n>You have entered an invalid user name,
            password or your account might be locked. Please try again.</p>
          }
          @if (loginState.toString() === LoginStateEnum.AccessError) {
          <p i18n>Access denied. Please contact your
            administrator.</p>
          }
          @if (loginState.toString() === LoginStateEnum.SignedOut) {
          <p i18n>You have been signed out. Completely close
            your web browser to ensure the privacy of recently-viewed data.</p>
          }
          @if (loginState.toString() === LoginStateEnum.SessionTimedOut) {
          <p i18n>You have been signed out due to
            inactivity. Please sign in again.</p>
          }
          @if (loginState.toString() === LoginStateEnum.ForgotPassword && forgetPwdState.toString() ===
          ForgetPwdStateEnum.Stage1) {
          <p i18n>To reset your password please enter
            your email below and we'll get you going again.</p>
          }
          @if (loginState.toString() === LoginStateEnum.ForgotPassword && forgetPwdState.toString() ===
          ForgetPwdStateEnum.Stage2) {
          <p i18n>Please contact your system administrator to
            retrieve your security token.</p>
          }
          @if (loginState.toString() === LoginStateEnum.Forbidden) {
          <p i18n>You do not have permission to view the
            requested page. Please sign in again and you will be redirected to the home page.</p>
          }
          @if (loginState.toString() === LoginStateEnum.ServerError) {
          <p i18n>The system is currently unavailable.
            Please try again later or contact your system administrator.</p>
          }
        </div>
        @if (loginState.toString() !== LoginStateEnum.ForgotPassword) {
        <div class="otsc-login-form-wrapper">
          <form name="loginForm" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div class="otsc-login-form">
              <input id="username" name="username" autofocus (change)="forgotPwdUsername.setValue(username.value)"
                formControlName="username" type="text" class="otsc-login-form-control"
                [ngClass]="{'otsc-login-form-control-error' : (username.invalid && (username.dirty || username.touched)) || (loginState.toString() !== LoginStateEnum.Welcome && loginState.toString() !== LoginStateEnum.PasswordWasReset && loginState.toString() !== LoginStateEnum.SignedOut)}"
                i18n-placeholder placeholder="User name" i18n-title title="User name" aria-label="User name"
                autocomplete="off" value="">
            </div>
            @if (loginState.toString() !== LoginStateEnum.ForgotPassword) {
            <div class="otsc-login-form">
              <input name="password" formControlName="password" type="password" class="otsc-login-form-control ot-mb-2"
                [ngClass]="{'otsc-login-form-control-error' : (password.invalid && (password.dirty || password.touched)) || loginState.toString() !== LoginStateEnum.Welcome && loginState.toString() !== LoginStateEnum.PasswordWasReset && loginState.toString() !== LoginStateEnum.SignedOut}"
                i18n-placeholder placeholder="Password" i18n-title title="Password" aria-label="Password"
                autocomplete="off">
              <button type="submit" class="otsc-signin-btn"
                [ngClass]="loginForm.valid && !inProgress ? 'otsc-signin-btn-enabled' : ''"
                [disabled]="loginForm.invalid || inProgress" i18n>Sign in</button>
            </div>
            }
          </form>
        </div>
        }
        @if (loginState.toString() === LoginStateEnum.ForgotPassword) {
        <div class="otsc-login-form-wrapper">
          <form name="forgotPwdForm" [formGroup]="forgotPwdForm" (ngSubmit)="onResetPassword()">
            <div class="otsc-login-form ot-form-control" style="text-align:left"
              [ngClass]="{'ot-form-control--is-invalid' : isErrorGenSecurityToken || isErrorPwdReset}">
              <input id="forgotPwdUsername" name="forgotPwdUsername"
                (change)="username.setValue(forgotPwdUsername.value)" formControlName="forgotPwdUsername" type="text"
                [readOnly]="forgetPwdState.toString() === ForgetPwdStateEnum.Stage2" class="otsc-login-form-control"
                [ngClass]="{'otsc-login-form-control-error-readonly' : (forgotPwdUsername.invalid && (forgotPwdUsername.dirty || forgotPwdUsername.touched) || isErrorGenSecurityToken || isErrorPwdReset)}"
                i18n-placeholder placeholder="User name" i18n-title title="User name" aria-label="User name"
                autocomplete="off" value="">
              @if (isErrorGenSecurityToken) {
              <p id="errorGenSecurityTokenMsg" class="ot-form-control__error-text" i18n>
                Error generating a security token. Please contact your administrator.
              </p>
              }
              @if (isErrorPwdReset) {
              <p id="errorResetPwdMsg" class="ot-form-control__error-text" i18n>
                Failed to reset password. Please verify your user name and security token.
              </p>
              }
            </div>
            <div class="otsc-login-form">
              @if (forgetPwdState.toString() === ForgetPwdStateEnum.Stage1) {
              <app-checkbox [identifier]="'isSecurityTokenGenerated'" formControlName="isSecurityTokenGenerated"
                [name]="'isSecurityTokenGenerated'" i18n-label [label]="'I already requested a security token'"
                i18n-arialabel [arialabel]="'I already requested a security token'">
              </app-checkbox>
              }
            </div>
            <div class="otsc-login-form">
              @if (forgetPwdState.toString() === ForgetPwdStateEnum.Stage2) {
              <div class="ot-level">
                <div class="ot-level__left">
                  <div class="ot-level__item">
                    @if (forgetPwdState.toString() === ForgetPwdStateEnum.Stage2) {
                    <input id="forgotPwdSecurityToken" name="forgotPwdSecurityToken"
                      formControlName="forgotPwdSecurityToken" [type]="showForgotPwdSecurityToken ? 'text': 'password'"
                      class="otsc-login-form-control otsc-input-with-btn"
                      [ngClass]="{'otsc-login-form-control-with-btn-error' : (forgotPwdSecurityToken.invalid && (forgotPwdSecurityToken.dirty || forgotPwdSecurityToken.touched))}"
                      i18n-placeholder placeholder="Security Token" i18n-title title="Security Token"
                      aria-label="Security Token" autocomplete="off" value="">
                    }
                  </div>
                </div>
                <div class="ot-level__right">
                  <div class="ot-level__item">
                    <button name="securityTokenToggleBtn" type="button" aria-label="icon" i18n-title
                      [title]="showForgotPwdSecurityToken ? 'Hide security token':'Show security token'"
                      class="ot-btn ot-btn--is-micro ot-btn--is-icon-btn"
                      (click)="showForgotPwdSecurityToken = !showForgotPwdSecurityToken">
                      <div class="ot-icon ot-icon__action">
                        <img
                          [src]="showForgotPwdSecurityToken ? './assets/icons/visibility-white-36dp.svg' : './assets/icons/visibility_off-white-36dp.svg'"
                          i18n-alt [alt]="showForgotPwdSecurityToken ? 'Hide security token' : 'Show security token'">
                      </div>
                    </button>
                  </div>
                </div>
              </div>
              }
            </div>
            <div class="otsc-login-form">
              @if (forgetPwdState.toString() === ForgetPwdStateEnum.Stage2) {
              <div class="ot-level">
                <div class="ot-level__left">
                  <div class="ot-level__item">
                    <div class="ot-form-control"
                      [ngClass]="{'ot-form-control--is-invalid' : (forgotPwdPassword.errors && forgotPwdPassword.errors.passwordValidationFailed)}">
                      <input name="forgotPwdPassword" formControlName="forgotPwdPassword"
                        [type]="showForgotPwdPassword ? 'text': 'password'"
                        class="otsc-login-form-control otsc-input-with-btn"
                        [ngClass]="{'otsc-login-form-control-with-btn-error' : (forgotPwdPassword.invalid && (forgotPwdPassword.dirty || forgotPwdPassword.touched))}"
                        i18n-placeholder placeholder="Password" i18n-title title="Password" aria-label="Password"
                        autocomplete="off" value="">
                      @if (forgotPwdPassword.errors && forgotPwdPassword.errors.passwordValidationFailed &&
                      forgotPwdPassword.errors.passwordValidationType === 'passwordValidationErrorPwdLength') {
                      <p id="passwordLengthErrorMsg" class="ot-form-control__error-text" i18n>
                        Password field must be at least eight characters in length.
                      </p>
                      }
                      @if (forgotPwdPassword.errors && forgotPwdPassword.errors.passwordValidationFailed &&
                      forgotPwdPassword.errors.passwordValidationType === 'passwordValidationErrorPwdLetter') {
                      <p id="passwordMissingLetterErrorMsg" class="ot-form-control__error-text" i18n>
                        Password field must contain at least one alphabetical character.
                      </p>
                      }
                      @if (forgotPwdPassword.errors && forgotPwdPassword.errors.passwordValidationFailed &&
                      forgotPwdPassword.errors.passwordValidationType === 'passwordValidationErrorPwdDigit') {
                      <p id="passwordMissingDigitErrorMsg" class="ot-form-control__error-text" i18n>
                        Password field must contain at least one numeric digit.
                      </p>
                      }
                    </div>
                  </div>
                </div>
                <div class="ot-level__right">
                  <div class="ot-level__item">
                    <button name="forgotPwdPasswordToggleBtn" type="button" aria-label="icon"
                      (click)="showForgotPwdPassword = !showForgotPwdPassword;" i18n-title
                      [title]="showForgotPwdPassword ? 'Hide password':'Show password'"
                      class="ot-btn ot-btn--is-micro ot-btn--is-icon-btn"
                      [ngClass]="(forgotPwdPassword.errors && forgotPwdPassword.errors.passwordValidationFailed) ? 'otsc-input-btn-error' : 'otsc-input-btn'">
                      <div class="ot-icon ot-icon__action">
                        <img
                          [src]="showForgotPwdPassword ? './assets/icons/visibility-white-36dp.svg' : './assets/icons/visibility_off-white-36dp.svg'"
                          i18n-alt [alt]="showForgotPwdPassword ? 'Hide password' : 'Show password'">
                      </div>
                    </button>
                  </div>
                </div>
              </div>
              }
            </div>
            <div class="otsc-login-form">
              @if (forgetPwdState.toString() === ForgetPwdStateEnum.Stage2) {
              <div class="ot-level">
                <div class="ot-level__left">
                  <div class="ot-level__item">
                    <div class="ot-form-control"
                      [ngClass]="{'ot-form-control--is-invalid' : (forgotPwdForm.errors && forgotPwdForm.errors.passwordNotSame)}">
                      <input name="forgotPwdConfirmPassword" formControlName="forgotPwdConfirmPassword"
                        [type]="showForgotPwdConfirmPassword ? 'text': 'password'"
                        class="otsc-login-form-control otsc-input-with-btn"
                        [ngClass]="{'otsc-login-form-control-with-btn-error' : (forgotPwdConfirmPassword.invalid && (forgotPwdConfirmPassword.dirty || forgotPwdConfirmPassword.touched))}"
                        i18n-placeholder placeholder="Confirm Password" i18n-title title="Confirm Password"
                        aria-label="Security Token" autocomplete="off" value="">
                      <p id="passwordDoNotMatchErrorMsg" class="ot-form-control__error-text" i18n>These passwords do not
                        match.</p>
                    </div>
                  </div>
                </div>
                <div class="ot-level__right">
                  <div class="ot-level__item">
                    <button name="forgotPwdConfirmPasswordToggleBtn" type="button" aria-label="icon"
                      (click)="showForgotPwdConfirmPassword = !showForgotPwdConfirmPassword;" i18n-title
                      [title]="showForgotPwdConfirmPassword ? 'Hide confirm password':'Show confirm password'"
                      class="ot-btn ot-btn--is-micro ot-btn--is-icon-btn"
                      [ngClass]="(forgotPwdForm.errors && forgotPwdForm.errors.passwordNotSame) ? 'otsc-input-btn-error' : 'otsc-input-btn'">
                      <div class="ot-icon ot-icon__action">
                        <img
                          [src]="showForgotPwdConfirmPassword ? './assets/icons/visibility-white-36dp.svg' : './assets/icons/visibility_off-white-36dp.svg'"
                          i18n-alt [alt]="showForgotPwdConfirmPassword ? 'Hide password' : 'Show password'">
                      </div>
                    </button>
                  </div>
                </div>
              </div>
              }
            </div>
            <div class="otsc-login-form otsc-form-padding">
              <div role="group" class="ot-btn-group ot-level">
                <div class="ot-level__left">
                </div>
                <div class="ot-level__center">
                  <div class="ot-level__item">
                    <button id="forgetPwdGoBackBtn" type="button" (click)="forgetPwdGoBack()" role="button" i18n-title
                      title="Go back" class="ot-btn ot-btn--is-outlined" i18n>
                      Go back
                    </button>
                    @if (forgetPwdState.toString() === ForgetPwdStateEnum.Stage1) {
                    <button id="forgetPwdContinueBtn" type="button" role="button" (click)="generateSecurityToken()"
                      i18n-title title="Continue"
                      [ngClass]="forgotPwdUsername.invalid || isErrorGenSecurityToken ? 'ot-btn--is-disabled' :  'ot-btn--is-secondary'"
                      [disabled]="forgotPwdUsername.invalid || pwdResetInProgress" class="ot-btn ot-btn--is-outlined"
                      i18n>
                      Continue
                    </button>
                    }
                    @if (forgetPwdState.toString() === ForgetPwdStateEnum.Stage2) {
                    <button id="forgetPwdResetPwdBtn" type="submit" role="button" i18n-title title="Reset Password"
                      [ngClass]="forgotPwdForm.invalid || pwdResetInProgress ? 'ot-btn--is-disabled' :  'ot-btn--is-secondary'"
                      [disabled]="forgotPwdForm.invalid || pwdResetInProgress" class="ot-btn ot-btn--is-outlined" i18n>
                      Reset password
                    </button>
                    }
                  </div>
                </div>
                <div class="ot-level__right">
                </div>
              </div>
            </div>
          </form>
        </div>
        }
        <div class="otsc-forgot-password">@if (loginState.toString() !== LoginStateEnum.ForgotPassword) {
          <a class="otsc-forgot-pwd-link" i18n tabindex="0" (keyup.enter)="forgetPwd(LoginStateEnum.ForgotPassword)"
            (click)="forgetPwd(LoginStateEnum.ForgotPassword)" i18n>Forgot Password?</a>
          }
        </div>
      </div>
      <div class="ot-splash-screen__footer otsc-copyright" i18n>
        Copyright © 2026 Open Text. All Rights Reserved. Trademarks owned by Open Text.
      </div>
    </div>
  </ng-scrollbar>
</div>